export default {
  setUserData: (state, user) => {
    state.user = user;
  },
  setCampaigns: (state, campaigns) => {
    state.campaigns = campaigns;
  },
  setScreenWidth: (state, newWidth) => {
    state.screenWidth = newWidth;
  },
  toggleMenu: (state, value) => {
    state.menuOpen = !state.menuOpen;
  },
  setCampaign: (state, campaign) => {
    state.campaign = campaign;
  },
  setReturnRoute: (state, route) => {
    state.returnRoute = route;
  },
  setUserAggregations: (state, aggregations) => {
    state.userDayAggregations = aggregations;
  },
  setDates: (state, value) => {
    state.dateFrom = value.from;
    state.dateTo = value.to;
  },
  setCompareDates: (state, value) => {
    state.dateCompareFrom = value.from;
    state.dateCompareTo = value.to;
  },
  setUserConversions: (state, value) => {
    state.userConversions = value;
  },
  setNotifications: (state, notifications) => {
    state.notifications = notifications;
  },
  selectCampaigns: (state, campaigns) => {
    state.selectedCampaigns = campaigns;
  },
  selectUser: (state, user) => {
    state.selectedUser = user;
  },
  setClicksByCampaign: (state, count) => {
    state.clicksByCampaign = count;
  },
  setSelectedSubPublisher: (state, subPublisher) => {
    state.selectedSubPublisher = subPublisher;
  }
};
